import justmyliveGoldTriangle from '@/assets/articles/justmylive-gold-triangle.jpg';
import orange0902EveningPrimrose from '@/assets/articles/orange0902-evening-primrose.jpg';
import wensunnyGoldTriangle from '@/assets/articles/wensunny-gold-triangle.jpg';
import kellyla1028BrighteningSpa from '@/assets/articles/kellyla1028-brightening-spa.jpg';
import mueyeb22BrighteningCourse from '@/assets/articles/mueyeb22-brightening-course.jpg';
import s045488DazhiSpa from '@/assets/articles/s045488-dazhi-spa.webp';
import hsiaobaoHomeSpa from '@/assets/articles/hsiaobao-home-spa.jpg';
import cher324HomeSpa from '@/assets/articles/cher324-home-spa.jpg';
import macy8166DiamondCourse from '@/assets/articles/macy8166-diamond-course.jpg';
import kikio717DiamondSeries from '@/assets/articles/kikio717-diamond-series.jpg';
import tramy888DazhiSpa from '@/assets/articles/tramy888-dazhi-spa.jpg';
import michellebuyRenewalCare from '@/assets/articles/michellebuy-renewal-care.jpg';
import olivechocFaceSpa from '@/assets/articles/olivechoc-face-spa.jpg';

export const TAB_LIST = ['完美禦顏金三角', '月見草活氧亮顏課程', '妳值得更好的對待'];

const articleCatalog = {
  justmyliveGoldTriangle: {
    title: '克麗緹娜臉部保養推薦 月見草禦顏系列 綻放煥亮月光肌 完美禦顏金三角 三步驟快速有感 揮別疲憊肌！',
    link: 'https://justmylive.pixnet.net/blog/post/50237904',
    image: justmyliveGoldTriangle,
    detail: {
      author: {
        name: 'justmylive',
      },
    },
  },
  orange0902EveningPrimrose: {
    title: '【保養】換季愛用的臉部保養推薦。克麗緹娜「月見草禦顏系列」撫平累痕，綻放煥亮月光肌',
    link: 'https://orange0902.pixnet.net/blog/posts/3050253540',
    image: orange0902EveningPrimrose,
    detail: {
      author: {
        name: 'orange0902',
      },
    },
  },
  wensunnyGoldTriangle: {
    title: '【臉部保養推薦】揮別疲累綻放煥亮月光肌，「克麗緹娜」月見草禦顏系列 完美禦顏金三角日常保養三步驟',
    link: 'https://wensunny.pixnet.net/blog/post/363936687',
    image: wensunnyGoldTriangle,
    detail: {
      author: {
        name: 'wensunny',
      },
    },
  },
  kellyla1028BrighteningSpa: {
    title: '做臉推薦：90分鐘讓妳的臉閃閃發亮，克麗緹娜活氧新肌SPA 月見草活氧亮顏課程，臉部抗老保養推薦',
    link: 'https://kellyla1028.pixnet.net/blog/post/49917920',
    image: kellyla1028BrighteningSpa,
    detail: {
      author: {
        name: 'kellyla1028',
      },
    },
  },
  mueyeb22BrighteningCourse: {
    title: '【產品體驗】克麗緹娜臉部保養推薦「月見草活氧亮顏課程」給你肌活綻放煥亮月光肌！',
    link: 'https://mueyeb22.pixnet.net/blog/post/89505838',
    image: mueyeb22BrighteningCourse,
    detail: {
      author: {
        name: 'mueyeb22',
      },
    },
  },
  s045488DazhiSpa: {
    title: '【台北SPA推薦】小資女的極致奢華享受，克麗緹娜法國花嬉美妍中心大直店，終於能大方展露素顏',
    link: 'https://s045488.pixnet.net/blog/post/556199074',
    image: s045488DazhiSpa,
    detail: {
      author: {
        name: 's045488',
      },
    },
  },
  hsiaobaoHomeSpa: {
    title: '居家SPA時光：）克麗緹娜 E.P.O. 淨膚美肌三步曲',
    link: 'https://hsiaobao.pixnet.net/blog/post/70119838',
    image: hsiaobaoHomeSpa,
    detail: {
      author: {
        name: 'hsiaobao',
      },
    },
  },
  cher324HomeSpa: {
    title: '有感胺基酸淨膚保養！居家臉部 Home SPA 洗出仙女肌！CHLITINA 克麗緹娜 E.P.O.＋系列',
    link: 'https://cher324.pixnet.net/blog/posts/15336128073',
    image: cher324HomeSpa,
    detail: {
      author: {
        name: 'cher324',
      },
    },
  },
  macy8166DiamondCourse: {
    title: '新北板橋｜臉部保養推薦｜克麗緹娜頂級鑽石光逆齡課程體驗｜肌膚瞬間光透亮',
    link: 'https://macy8166.pixnet.net/blog/post/341966301',
    image: macy8166DiamondCourse,
    detail: {
      author: {
        name: 'macy8166',
      },
    },
  },
  kikio717DiamondSeries: {
    title: '「體驗」臉部保養推薦，克麗緹娜 X 逆齡雙星 X 鑽石光亮白，肌膚重現光采白皙',
    link: 'https://kikio717.pixnet.net/blog/post/226450099-%E3%80%8C%E9%AB%94%E9%A9%97%E3%80%8D%E8%87%89%E9%83%A8%E4%BF%9D%E9%A4%8A%E6%8E%A8%E8%96%A6-%E5%85%8B%E9%BA%97%E7%B7%B9%E5%A8%9Cx%E7%B2%89%E7%B4%85%E9%91%BD%E7%B3%BB',
    image: kikio717DiamondSeries,
    detail: {
      author: {
        name: 'kikio717',
      },
    },
  },
  tramy888DazhiSpa: {
    title: '【保養】再忙也要美！快速回春貴婦按摩課程，克麗緹娜法國花嬉美妍中心大直店',
    link: 'https://tramy888.pixnet.net/blog/post/493486610',
    image: tramy888DazhiSpa,
    detail: {
      author: {
        name: 'tramy888',
      },
    },
  },
  michellebuyRenewalCare: {
    title: '讓好肌膚還會更好！全新開幕克麗緹娜法國花嬉美妍中心，經典精準煥膚護理',
    link: 'https://michellebuy.pixnet.net/blog/post/47138703',
    image: michellebuyRenewalCare,
    detail: {
      author: {
        name: 'michellebuy',
      },
    },
  },
  olivechocFaceSpa: {
    title: '【觀玲老師愛SPA】偶爾還是要來一下臉部SPA，保養節奏慢下來，膚況真的會更穩',
    link: 'https://olivechoc.pixnet.net/blog/post/36570797',
    image: olivechocFaceSpa,
    detail: {
      author: {
        name: 'olivechoc',
      },
    },
  },
};

const articleGroups = {
  完美禦顏金三角: [
    articleCatalog.justmyliveGoldTriangle,
    articleCatalog.orange0902EveningPrimrose,
    articleCatalog.wensunnyGoldTriangle,
    articleCatalog.kikio717DiamondSeries,
    articleCatalog.hsiaobaoHomeSpa,
    articleCatalog.cher324HomeSpa,
    articleCatalog.mueyeb22BrighteningCourse,
    articleCatalog.macy8166DiamondCourse,
    articleCatalog.michellebuyRenewalCare,
    articleCatalog.kellyla1028BrighteningSpa,
  ],
  月見草活氧亮顏課程: [
    articleCatalog.kellyla1028BrighteningSpa,
    articleCatalog.mueyeb22BrighteningCourse,
    articleCatalog.macy8166DiamondCourse,
    articleCatalog.tramy888DazhiSpa,
    articleCatalog.michellebuyRenewalCare,
    articleCatalog.s045488DazhiSpa,
    articleCatalog.olivechocFaceSpa,
    articleCatalog.kikio717DiamondSeries,
    articleCatalog.hsiaobaoHomeSpa,
    articleCatalog.cher324HomeSpa,
  ],
  妳值得更好的對待: [
    articleCatalog.s045488DazhiSpa,
    articleCatalog.tramy888DazhiSpa,
    articleCatalog.michellebuyRenewalCare,
    articleCatalog.olivechocFaceSpa,
    articleCatalog.kellyla1028BrighteningSpa,
    articleCatalog.macy8166DiamondCourse,
    articleCatalog.kikio717DiamondSeries,
    articleCatalog.hsiaobaoHomeSpa,
    articleCatalog.cher324HomeSpa,
    articleCatalog.justmyliveGoldTriangle,
  ],
};

export const getArticlesPage = (tagName, page = 1, pageSize = 9) => {
  const articles = articleGroups[tagName] || [];
  const startIndex = (page - 1) * pageSize;
  const endIndex = startIndex + pageSize;

  return {
    articles: articles.slice(startIndex, endIndex),
    pageTotal: Math.max(1, Math.ceil(articles.length / pageSize)),
  };
};
